import CryptoJS from "crypto-js";
const key = "accio-jobs-event-2023";

export const encryptData = (data: any) => {
  const encrypted_data = JSON.stringify(data);
  console.log("data before en", encrypted_data);
  const en = CryptoJS.AES.encrypt(encrypted_data, key);
  console.log("data en", CryptoJS.AES.decrypt(en, key));
  return CryptoJS.AES.encrypt(encrypted_data, key).toString();
};
